import React, {useContext, useState} from "react";
import {ContextAppState} from "@app/context.ts";
import {QRCodeCanvas} from "qrcode.react";

export const AccountReceivePage = ({}) => {
    const appState = useContext(ContextAppState);
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(appState.wallet.address);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error("Failed to copy address", err);
        }
    };


    // useEffect(() => {
    //     if (appState.type === 'Telegram') {
    //         // @ts-ignore
    //         const tg = window.Telegram.WebApp;
    //         tg.BackButton.show();
    //         const handleBackClick = () => {
    //             window.history.back();
    //         };
    //         tg.BackButton.onClick(handleBackClick);
    //
    //         return () => {
    //             tg.BackButton.hide();
    //             tg.BackButton.offClick(handleBackClick);
    //         };
    //     }
    // }, [appState.type]);

    return (
        <div className="w-screen h-screen flex items-center justify-center px-4 bg-gradient-to-b from-orange-50/20 via-orange-100/10 to-transparent">
            <div
                className="max-w-md w-full border border-orange-200/60 p-6 shadow-xl backdrop-blur-md rounded-2xl bg-gradient-to-br from-orange-100/20 via-orange-50/10 to-transparent"
            >
                <h2 className="text-2xl font-bold text-orange-300 text-center mb-6 drop-shadow-sm">
                    Receive Tokens
                </h2>

                <div className="flex justify-center mb-6">
                    <QRCodeCanvas
                        value={appState.wallet.address}
                        size={160}
                        fgColor="#ea580c"
                        bgColor="transparent"
                        className="rounded-xl shadow-lg"
                    />
                </div>

                <div className="text-center text-sm text-orange-300 font-medium mb-2">
                    Your Solana address
                </div>

                <button
                    onClick={handleCopy}
                    className="w-full text-center text-sm font-mono break-all text-orange-300 border border-orange-300 rounded-xl px-4 py-2 transition duration-200 hover:bg-orange-50/20 active:bg-orange-100/30 shadow-sm backdrop-blur-sm"
                    title="Click to copy"
                >
                    {appState.wallet.address}
                </button>

                {copied && (
                    <div className="mt-4 text-center text-xs text-green-600 font-medium animate-fade-in">
                        Copied to clipboard!
                    </div>
                )}
            </div>
        </div>
    );
};
